import React from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Collapse
} from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

class SurveyTemplateDetailQuestion extends React.Component {
  constructor() {
    super();

    this.state = {
      collapse: false,
    }

    this.toggleCard = this.toggleCard.bind(this);
    this.renderAnswers = this.renderAnswers.bind(this);
  }

  toggleCard() {
    this.setState({ collapse: !this.state.collapse });
  }

  renderAnswers(answers) {
    const answerList = answers.map((answer, index) => {
      return (
        <li key={index}>
          <div className="answer-container">
            {answer.answer}
          </div>
        </li>
      )
    });

    return (
      <ul>
        {answerList}
      </ul>
    )
  }

  render() {
    return (
      <Card className="question-answer-container">
        <CardBody>
          <Row onClick={this.toggleCard}>
            <Col xs="10">
              <span className="question">
                {this.props.questionAnswers.question}
              </span>
              <span className="text-muted">
                ({this.props.questionAnswers.answers_attributes.length} options)
              </span>
            </Col>
          </Row>
          <Collapse isOpen={this.state.collapse}>
            <CardBody>
              {this.renderAnswers(this.props.questionAnswers.answers_attributes)}
            </CardBody>
          </Collapse>
        </CardBody>
      </Card>
    )
  }
}

export default SurveyTemplateDetailQuestion;



// WEBPACK FOOTER //
// ./src/components/customSurvey/SurveyTemplateDetailQuestion.js